import * as React from 'react'
import {connect} from 'react-redux'

import * as track from '../../../track/track'
import * as userInteractionActions from '../../../actions/userInteractions'
import {isTwoOrMoreBusinessDaysAway} from '../utils'
import SolvvyButton, {SOLVVY_RETURN_ITEM} from '../../_shared/SolvvyButton'

import {AddItemsNavButton} from './AddItemsNavButton'
import {ButtonGroupList} from '../_components/ButtonGroupList'
import {CartContext} from '../../../contexts/CartContext'
import {EventOrder} from '../types/eventData'
import {OrderItemsList} from './OrderItemsList'
import {RemoveItemsNavButton} from '../../RemoveItemsNavButton'
import ReplacementsLink from '../ReplacementsLink'

import styles from './styles.module.scss'

interface OrderItemsProps {
  openBuyEditOrderErrorModal: () => void
  openTimeToEventErrorModal: () => void
  openParticipantPermissionModal: () => void
  isGroup: boolean
  eventDate: string
  eventOrder: EventOrder
  isParticipantUser: boolean
}

const OrderItems: React.FC<OrderItemsProps> = ({
  openBuyEditOrderErrorModal,
  openTimeToEventErrorModal,
  openParticipantPermissionModal,
  isGroup,
  eventDate,
  eventOrder,
  isParticipantUser,
}) => {
  const {isActive, cart, activateCart} = React.useContext(CartContext)
  const {eventId, homeTryOn, id: orderId, purchase, rental} = eventOrder
  const isMatchingCartForOrder = cart?.orderId === orderId

  return (
    <div className={styles.container}>
      <OrderItemsList wrapperClassName={styles['items-container']} eventOrder={eventOrder} />

      {!homeTryOn && (
        <ButtonGroupList>
          {rental ? (
            <>
              <AddItemsNavButton
                shouldNotShow={isActive && !isMatchingCartForOrder}
                isAddable={isTwoOrMoreBusinessDaysAway(new Date(eventDate))}
                onError={() => {
                  openTimeToEventErrorModal()
                  track.addItemErrorClicked()
                }}
                onLinkClick={() => {
                  activateCart(eventId, orderId, purchase)
                  track.addItemClicked()
                }}
                linkState={{
                  eventDate,
                  partyFilter: isGroup ? 'Group' : 'Individual',
                }}
              />

              <RemoveItemsNavButton
                isParticipantUser={isParticipantUser}
                eventId={eventId}
                orderId={orderId}
                openModal={openParticipantPermissionModal}
              />
            </>
          ) : (
            <>
              <li>
                <button onClick={openBuyEditOrderErrorModal}>Edit Order</button>
              </li>
              <li>
                <SolvvyButton workflowId={SOLVVY_RETURN_ITEM}>Return Item</SolvvyButton>
              </li>
            </>
          )}

          <ReplacementsLink eventOrder={eventOrder} />
        </ButtonGroupList>
      )}
    </div>
  )
}

const mapDispatchToProps = {
  openBuyEditOrderErrorModal: userInteractionActions.openBuyEditOrderErrorModal,
  openTimeToEventErrorModal: userInteractionActions.openTimeToEventErrorModal,
  openParticipantPermissionModal: userInteractionActions.openParticipantPermissionModal,
}

export default connect(null, mapDispatchToProps)(OrderItems)
